import { GridFilterItem } from '@mui/x-data-grid';
import { DealerStatement } from '../../types/statistics';

export const STATUS_FIELD = 'statementStatusLabel';
export const PAYMENT_FIELD = 'paymentFilter';

export const STATUS_VALUES = ['Vyšlá', 'Nevyšlá', 'Čekající'] as const;
export const PAYMENT_VALUES = ['Zaplacená', 'Nezaplacená', 'Částečně zaplacená'] as const;

/** Stav řádku výkazu z documents[].paymentStatus.status (paid | notPaid | partiallyPaid). Bez dokumentů null = nespadá do filtru. */
export const getPaymentFilterValue = (
  row: Pick<DealerStatement, 'documents'>
): (typeof PAYMENT_VALUES)[number] | null => {
  const docs = row.documents;
  if (!docs || docs.length === 0) return null;

  const statuses = docs.map((d) => d.paymentStatus.status);
  if (statuses.every((s) => s === 'paid')) return 'Zaplacená';
  if (statuses.every((s) => s === 'notPaid')) return 'Nezaplacená';
  return 'Částečně zaplacená';
};

export const buildQuickFilterItems = (chips: string[]): GridFilterItem[] => {
  const statuses = chips.filter((c) => (STATUS_VALUES as readonly string[]).includes(c));
  const payments = chips.filter((c) => (PAYMENT_VALUES as readonly string[]).includes(c));
  return [
    ...(statuses.length ? [{ field: STATUS_FIELD, operator: 'isAnyOf', value: statuses }] : []),
    ...(payments.length ? [{ field: PAYMENT_FIELD, operator: 'isAnyOf', value: payments }] : [])
  ];
};

export const isQuickFilterItem = (item: GridFilterItem) => item.field === STATUS_FIELD || item.field === PAYMENT_FIELD;
